import type {Dimensions} from "../../types/types"
import Input from "../Input/Input"
import styles from "./SizesCropInputs.module.css"

interface SizesCropInputsProps {
    onSizeChange: (dim: "width" | "height", value: string) => void
    cropState: Dimensions
    disabled: boolean
    className?: string
}

export const SizesCropInputs = ({
    onSizeChange,
    cropState,
    disabled,
    className,
}: SizesCropInputsProps) => {
    return (
        <section className={styles.sizesContainer}>
            <Input
                disabled={disabled}
                className={styles.width}
                type="number"
                leftText="w"
                value={cropState.width}
                onChange={(e) => onSizeChange("width", e.target.value)}
                min="1"
            />
            <Input
                disabled={disabled}
                className={styles.height}
                type="number"
                leftText="h"
                value={cropState.height}
                onChange={(e) => onSizeChange("height", e.target.value)}
                min="1"
            />
        </section>
    )
}
